module.exports = __webpack_public_path__ + "img/book-min.9a1b227b.png";